import { useEffect } from "react";
import { api } from "@/api";
import { getBuyerAuthToken } from "@/api/token";
import { useProfile } from "@/store/profile";
import { useWishlist } from "@/store/wishlist";
import {
	markReferralAttempted,
	markReferralVisited,
	readReferralMeta,
	readReferralPromo,
	referralAttributePendingFor,
	referralVisitPending,
} from "./referral-promo";

/**
 * Отправить переход по партнёрской ссылке и — если покупатель уже вошёл —
 * попросить шлюз засчитать его партнёру. Ошибки глотаем: статистика партнёра
 * не должна мешать покупке.
 */
export function useReferralPromo(): void {
	const clientId = useWishlist((s) => s.clientId);
	const token = useProfile((s) => s.token);

	useEffect(() => {
		const code = readReferralPromo();
		if (!code || !referralVisitPending() || !clientId) return;
		api.referral
			.visit(code, clientId, readReferralMeta())
			.then(markReferralVisited)
			.catch(() => undefined);
	}, [clientId]);

	useEffect(() => {
		if (!token || !getBuyerAuthToken()) return;
		const key = token.slice(-12);
		const code = referralAttributePendingFor(key);
		if (!code) return;
		api.referral
			.attribute(code)
			.then(() => markReferralAttempted(key))
			.catch(() => undefined);
	}, [token]);
}
